import { Component, OnInit, OnDestroy } from '@angular/core';
import { AttrFilter, AttributeFilterService, AttrFilterColumn } from 'app/services/attribute-filter.service';
import { ColumnFilter } from 'app/services/gfo.service';
import { FilterStatus } from 'app/interfaces/column-filter.interface';
import { Subscription } from 'rxjs';
// import { MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-feat-attribute-filters-popup',
  templateUrl: './feat-attribute-filters-popup.component.html',
  styleUrls: ['./feat-attribute-filters-popup.component.css']
})
export class FeatAttributeFiltersPopupComponent implements OnInit, OnDestroy {

	attrFilters: AttrFilter[] = [];

	attrFilterStatus: FilterStatus = 'clean';

	attrFilterColumns: AttrFilterColumn[];

	showRemoveAll: boolean;

	maxNumOfFilter = 5;

	private attrFiltersSub: Subscription;
	private filterColumnsSub: Subscription;
	constructor(
		// private dialog: MatDialogRef<FeatAttributeFiltersPopupComponent>,
		private toastr: ToastrService,
		private attrFilterService: AttributeFilterService
	) { }

	// cancel() {
	// 	this.dialog.close();
	// }
	applyAttrFilter() {
		this.attrFilterService.attrFilters.next({
			source: 'popup',
			filters: this.attrFilters
		});
		// this.dialog.close();
	}
	addEmptyFilter() {
		if (this.attrFilters.length >= this.maxNumOfFilter) {
			this.toastr.info('exceed max filter number');
			return;
		}
		this.attrFilters.push({
			filter: null
		});
	}
	removeFilter(idx) {
		if (this.attrFilters.length === 1) {
			return;
		}
		this.attrFilters.splice(idx, 1);
		// this.applyAttrFilter();
		this.triggerFilterChangeWithoutGetData();
	}
	removeAllAttrFilters() {
		this.attrFilterService.clearAttrFilters();
	}
	async onAttrFilterChange(event: ColumnFilter, idx: number) {
		this.attrFilters[idx].filter = event;
		if (event) {
			this.updateFilterStatus('dirty');
		} else {
			// User remove a filter manually
			if (this.attrFilterStatus !== 'clean') {
				this.updateFilterStatus('dirty');
			} else { // User remove filters by clicking filter-remove button // filterStatus's been set clean in clearFilter()
			}
		}

		this.triggerFilterChangeWithoutGetData();
		// TODO

		// if (this.current.contentKey === 'myLayers' && !this.qcFilterInfo.isQcFilter) {
		// 	// Update domain filters
		// 	// Hard code layer id filter
		// 	const layerIdFilter = this.gfoService.getFilter(
		// 		'gly_id', // ???
		// 		this.appinfoService.filterOperators.eq.name,
		// 		this.selectedLayer.id
		// 	);
		// 	this.attrFilters.forEach(f => {
		// 		if (f !== this.attrFilters[idx]) {

		// 			// TODO: domain filter

		// 			// if (filterName === 'filter1') {
		// 			// 	this.domainFilter2 = [layerIdFilter];
		// 			// 	if (event) {
		// 			// 		this.domainFilter2.push(event);
		// 			// 	}
		// 			// } else {
		// 			// 	this.domainFilter1 = [layerIdFilter];
		// 			// 	if (event) {
		// 			// 		this.domainFilter1.push(event);
		// 			// 	}
		// 			// }
		// 		}
		// 	});

		// }
	}
	private triggerFilterChangeWithoutGetData() {
		this.attrFilterService.attrFilters.next({
			source: 'popup',
			filters: this.attrFilters,
			skipGetData: true
		});
	}
	private updateFilterStatus(status: FilterStatus) {
		this.attrFilterStatus = status;
	}
	ngOnInit() {
		let isInit = true;
		this.attrFiltersSub = this.attrFilterService.attrFilters.subscribe(data => {
			if (isInit ||  data.source !== 'popup') {
				this.attrFilters = JSON.parse(JSON.stringify(data.filters));
				if (!this.attrFilters.length) {
					this.addEmptyFilter();
				}
				isInit = false;
			}
		});
		this.filterColumnsSub = this.attrFilterService.attrFilterColumns.subscribe(data => {
			this.attrFilterColumns = data || [];
		});
	}
	ngOnDestroy() {
		this.attrFiltersSub.unsubscribe();
		this.filterColumnsSub.unsubscribe();
	}
}
